var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":"silver","large":"","title":"Close"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(" mdi-close ")])
}
var staticRenderFns = []

export { render, staticRenderFns }